import useUtils from "hooks/useUtils";
import { getFilePathWithBackendUrl } from "utils/helpers/common/http-methods";
import { PictureDTO } from "../shared/picture.dto";

export class MinorDTO {
  id: number;
  firstName: string = "";
  lastName: string = "";
  language: string = "";
  username: string = "";
  dob: string = "";
  phone: string = "";
  email: string = "";
  gender: string = "";
  interest: string[] = [];
  password: string = "";
  retypePassword: string = "";
  skillLevel: string = "";
  profilePicUrl: any;
  profilePicId: number;
  pastExperiences: number = 0;
  joinedEventsCount: string = "";
  isLearningAssessment: boolean = false;
  isCoreConceptAssessment: boolean = false;

  constructor(data: Partial<MinorDTO> = {}) {
    for (let key in data) {
      if (key === "profilePic") {
        this.profilePicUrl = getFilePathWithBackendUrl(
          data[key].fileDownloadUri
        );
        this.profilePicId = data[key].profilePicId;
      } else {
        this[key] = data[key];
      }
    }
  }
}

enum SKILL_LEVELS {
  EXCEPTIONAL_LEARNER = "EXCEPTIONAL_LEARNER",
  APPROPRIATE_FOR_AGE_LEVEL = "APPROPRIATE_FOR_AGE_LEVEL",
  BOTH = "BOTH",
}
